export default "__VITE_PUBLIC_ASSET__d6c6c48d__"